<template>
  <a class="close lightboxClose" href="#!"><i class="fas fa-times-circle"></i></a>
</template>

<script>
export default {
  name: 'LightboxClose'
}
</script>
